import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CardFooter,
  Button,
  Label,
  FormGroup,
  Input,
} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTable.js";
import { useMemo, React, useState, useEffect, useContext } from "react";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { MainContext } from "context/MainContext.js";
import { ToastContainer, toast } from "react-toastify";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaCheckCircle } from "react-icons/fa";

import Moment from "moment";

import LoadingOverlay from "react-loading-overlay";
import Utilities from "components/Utils/utilities";
LoadingOverlay.propTypes = undefined;

const FirmwareList = () => {
  const history = useHistory();
  const [alert, setAlert] = useState(null);
  const privileges = useContext(MainContext);
  const [showLoading, setShowLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState([]);

  const [selectedFirmware, setSelectedFirmware] = useState(null);

  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["firmwares.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  const [forceRefreshCount, setForceRefreshCount] = useState(0);

  function handleFirmwareChange(e) {
    const { value } = e.target;

    setSelectedFirmware(value);
  }

  const setBaseline = (foldername, baselineValue) => {
    setShowLoading(true);
    fetch("/api/v1/firmware/baseline", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        folderName: foldername,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured while setting the baseline", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg([]);

          toast.success(
            baselineValue
              ? "Baseline removed successfully"
              : "Baseline defined successfully",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );

          setForceRefreshCount((prevValue) => prevValue + 1);
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const deleteFirmware = (foldername, force) => {
    setShowLoading(true);
    fetch("/api/v1/firmware/delete", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        folderName: foldername,
        force: force,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);

        if (
          actualData.error_code &&
          actualData.error_code[0] ==
            "Unable to delete a firmware currently used by one or more devices"
        ) {
          setAlert(
            <ReactBSAlert
              warning
              style={{ display: "block", marginTop: "-100px" }}
              title="This firmware is used by one or more device, are you sure you want to delete it ?"
              onConfirm={() => {
                deleteFirmware(foldername, true);
                hideAlert();
              }}
              onCancel={() => hideAlert()}
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle="info"
              confirmBtnText="Yes"
              cancelBtnText="Cancel"
              showCancel
              btnSize=""
            >
              You will not be able to recover this firmware '{foldername}'
            </ReactBSAlert>,
          );
        } else if (actualData.error_code) {
          toast.error("A problem occured while deleting the firmware", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          toast.success("Firmware deleted successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
          setForceRefreshCount((prevValue) => prevValue + 1);
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const swap = () => {
    setShowLoading(true);
    fetch("/api/v1/firmware/swap", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        devices: selectedDevices,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);

        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error(
            "A problem occured while activating the alternate version",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
        } else {
          setErrorMsg([]);
          toast.success(
            "The alternate version activation command have been sent successfully",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
          setSelectedDevices([]);
          setForceRefreshCount((prevValue) => prevValue + 1);
        }
      })
      .catch((err) => {
        console.log(err.message);
        setErrorMsg(err.message);
        setShowLoading(false);
      });
  };

  const upgrade = (noSwap) => {
    setShowLoading(true);
    fetch("/api/v1/firmware/upgrade", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        firmware: selectedFirmware,
        devices: selectedDevices,
        noSwap: noSwap,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);

        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured while upgrading the firmware", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg([]);
          toast.success(
            noSwap ? "Uploading has started" : "Update process has started",
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
          setSelectedDevices([]);
          setForceRefreshCount((prevValue) => prevValue + 1);
        }
      })
      .catch((err) => {
        console.log(err.message);
        setErrorMsg([err.message]);
        setShowLoading(false);
      });
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const showAlert = (action) => {
    if (action == "download") {
      setAlert(
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Download firmware to GAM"
          onConfirm={() => {
            upgrade(true);
            hideAlert();
          }}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="info"
          confirmBtnText="Proceed"
          cancelBtnText="Cancel"
          showCancel
          btnSize=""
        >
          This action will start downloading the selected firmware to the GAM
          without activating it. Do you want to continue?
        </ReactBSAlert>,
      );
    } else if (action == "download_activate") {
      setAlert(
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Download and activate firmware"
          onConfirm={() => {
            upgrade(false);
            hideAlert();
          }}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="info"
          confirmBtnText="Proceed"
          cancelBtnText="Cancel"
          showCancel
          btnSize=""
        >
          This action will start downloading the selected firmware to the GAM
          and then activate it. Do you want to continue?
        </ReactBSAlert>,
      );
    } else if (action == "alternate_activate") {
      setAlert(
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Activate alternate firmware version"
          onConfirm={() => {
            swap();
            hideAlert();
          }}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="info"
          confirmBtnText="Proceed"
          cancelBtnText="Cancel"
          showCancel
          btnSize=""
        >
          This action will activate the alternate firmware version already
          installed on the device. Do you want to continue?
        </ReactBSAlert>,
      );
    }
  };

  function handleDeviceCheckbox(e) {
    const { value, checked } = e.target;

    deviceColumns = null;

    if (checked) {
      setSelectedDevices((selectedDevices) => [...selectedDevices, value]);
    } else {
      setSelectedDevices((device) => device.filter((v) => v !== value));
    }
  }

  const handleSelectAll = (e, data) => {
    const { checked } = e.target;

    if (checked) {
      setSelectAll(true);
      setSelectedDevices([]);
      setSelectedDevices(data.map((device) => device.serial));
    } else {
      setSelectAll(false);
      setSelectedDevices([]);
    }
  };

  var firmwareColumns = [
    {
      accessor: "selectorFirmware",
      sortable: false,
      filterable: false,
      disableExport: true,
      flex: "0 1 7%",
      Cell: (props) => {
        const userLevel = sessionStorage.getItem("privilegeLevel");
        if (userLevel >= 15) {
          return (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Input
                type="radio"
                style={{
                  width: "17px",
                  height: "17px",
                }}
                value={props.row.original.folderName}
                checked={selectedFirmware === props.row.original.folderName}
                onChange={handleFirmwareChange}
              />{" "}
            </div>
          );
        } else {
          return <div></div>;
        }
      },
    },
    {
      Header: "Compatibility",
      accessor: "compatibility",
      sortBy: "compatibility",
      flex: "1 1 0",
    },
    {
      Header: "Version",
      accessor: "version",
      sortBy: "version",
      flex: "1 1 0",
    },
    {
      Header: "Revision",
      accessor: "revision",
      sortBy: "revision",
      flex: "1 1 0",
    },
    {
      Header: "Baseline",
      accessor: "baseline",
      sortBy: "baseline",
      flex: "0 1 12%",
      Cell: (props) => {
        var icon = <FaCheckCircle className="text-primary tableIconFontSize" />;

        return <div>{props.value ? icon : ""}</div>;
      },
    },
    {
      Header: "Date",
      accessor: "date",
      sortBy: "date",
      flex: "1 1 0",
      show: false,
      Cell: (props) => {
        return (
          <div>
            {props.value
              ? props.settings.general_convert_date_with_user_timezone ===
                "true"
                ? Moment(props.value)
                    .tz(props.settings.user_timezone)
                    .format("yy-MM-DD")
                : Moment.utc(props.value).format("yy-MM-DD")
              : ""}
          </div>
        );
      },
    },
    {
      Header: "Folder Name",
      accessor: "folderName",
      sortBy: "folderName",
      flex: "1 1 0",
      show: false,
      sortable: false,
      filterable: false,
      disableExport: true,
    },
    {
      Header: "",
      accessor: "actions",
      Cell: (props) => {
        return (
          <UncontrolledDropdown direction="down">
            <DropdownToggle
              caret
              color="info"
              style={{
                padding: "6px 14px 6px 14px",
                margin: "0px",
              }}
            >
              Actions
            </DropdownToggle>
            <DropdownMenu container={"body"}>
              <DropdownItem
                onClick={() =>
                  setBaseline(
                    props.row.original.folderName,
                    props.row.original.baseline,
                  )
                }
              >
                {props.row.original.baseline
                  ? "Unset Baseline"
                  : "Set Baseline"}
              </DropdownItem>
              <DropdownItem
                onClick={() =>
                  deleteFirmware(props.row.original.folderName, false)
                }
              >
                Delete Firmware
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
      flex: "1 1 0",
      padding: "0px",
      sortable: false,
      filterable: false,
    },
  ];

  var deviceColumns = [
    {
      accessor: "selector",
      sortable: false,
      filterable: false,
      disableExport: true,
      flex: "0 1 5%",
      Header: (props) => {
        const userLevel = sessionStorage.getItem("privilegeLevel");
        if (userLevel >= 15) {
          return (
            <div style={{ paddingLeft: "0px", paddingBottom: "8px" }}>
              <FormGroup check>
                <Label check>
                  <>
                    <Input
                      type="checkbox"
                      name="deviceAll"
                      onChange={(event) => handleSelectAll(event, props.data)}
                      checked={selectAll}
                    />
                    <span className="form-check-sign" />
                  </>
                </Label>
              </FormGroup>
            </div>
          );
        } else {
          return (
            <div style={{ paddingLeft: "8px", paddingBottom: "8px" }}></div>
          );
        }
      },
      Cell: (props) => {
        const userLevel = sessionStorage.getItem("privilegeLevel");
        if (userLevel >= 15) {
          return (
            <div style={{ paddingLeft: "7px", paddingBottom: "7px" }}>
              {props.row.original.upgradeStatus == "idle" ||
              props.row.original.upgradeStatus
                .toLowerCase()
                .includes("error") ||
              props.row.original.upgradeStatus ==
                "Upgrade Done Successfully" ? (
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      value={props.row.original.serial}
                      checked={selectedDevices.includes(
                        props.row.original.serial,
                      )}
                      onChange={handleDeviceCheckbox}
                    />
                    <span className="form-check-sign" />
                  </Label>
                </FormGroup>
              ) : (
                ""
              )}
            </div>
          );
        } else {
          <div style={{ paddingLeft: "7px", paddingBottom: "7px" }}></div>;
        }
      },
    },
    {
      Header: "System Name",
      accessor: "systemName",
      sortBy: "systemName",
      flex: "1 1 0",
    },
    {
      Header: "IP Address",
      accessor: "ipAddress",
      sortBy: "ipAddress",
      flex: "1 1 0",
    },
    {
      Header: "Model",
      accessor: "model",
      sortBy: "model",
      flex: "1 1 0",
    },
    {
      Header: "Current Version",
      accessor: "currentVersion",
      sortBy: "currentVersion",
      flex: "1 1 0",
      Cell: (props) => {
        var color = "";
        if (props.row.original.baseline) {
          color = "lightgreen";
        }

        return (
          <div style={{ backgroundColor: color, width: "100%" }}>
            {props.value}
          </div>
        );
      },
    },
    {
      Header: "Alternate Version",
      accessor: "swapVersion",
      sortBy: "swapVersion",
      flex: "1 1 0",
      Cell: (props) => {
        var color = "";
        if (props.row.original.swapBaseline) {
          color = "lightgreen";
        }

        return (
          <div style={{ backgroundColor: color, width: "100%" }}>
            {props.value}
          </div>
        );
      },
    },
    {
      Header: "Serial",
      accessor: "serial",
      sortBy: "serial",
      flex: "1 1 0",
    },
    {
      Header: "Upgrade Status",
      accessor: "upgradeStatus",
      sortBy: "upgradeStatus",
      flex: "1 1 0",
    },
    {
      Header: "baseline",
      accessor: "baseline",
      sortBy: "baseline",
      flex: "1 1 0",
      show: false,
      filterable: false,
      disableExport: true,
    },
    {
      Header: "swapBaseline",
      accessor: "swapBaseline",
      sortBy: "swapBaseline",
      flex: "1 1 0",
      show: false,
      filterable: false,
      disableExport: true,
    },
    {
      Header: "isActive",
      accessor: "isActive",
      sortBy: "isActive",
      flex: "1 1 0",
      show: false,
      filterable: false,
      disableExport: true,
    },
  ];

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        {alert}
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Firmware Versions</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            {errorMsg.length > 0 ? (
              <div
                style={{
                  backgroundColor: "#FFC0A4",
                  border: "1px solid #ef8157",
                  color: "#66615b",
                  paddingTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <ul>
                  {errorMsg.map((d, index) => (
                    <li key={index}>{d}</li>
                  ))}
                </ul>
              </div>
            ) : (
              ""
            )}
            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <ReactTable
                      query="/api/v1/firmware/list"
                      columns={firmwareColumns}
                      title="Mimo Firmware"
                      className="-striped -highlight primary-pagination"
                      forceRefresh={forceRefreshCount}
                      param="mimo"
                      showPagination={false}
                      showTitle={true}
                      showActionsButton={false}
                    />
                  </CardBody>
                </Card>
              </Col>
              <Col>
                <Card>
                  <CardBody>
                    <ReactTable
                      query="/api/v1/firmware/list"
                      columns={firmwareColumns}
                      title="Coax Firmware"
                      className="-striped -highlight primary-pagination"
                      forceRefresh={forceRefreshCount}
                      param="coax"
                      showPagination={false}
                      showTitle={true}
                      showActionsButton={false}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <ReactTable
                      query="/api/v1/firmware/device/list"
                      columns={deviceColumns}
                      className="-striped -highlight primary-pagination"
                      title="Firmware Devices"
                      showPagination={false}
                      showTitle={false}
                      submethodParam={selectedDevices}
                    />
                  </CardBody>
                  <CardFooter>
                    {sessionStorage.getItem("privilegeLevel") >= 15 ? (
                      <Row>
                        <Col>
                          <Button
                            className="btn-round"
                            color="info"
                            onClick={() => showAlert("download")}
                          >
                            Download Only
                          </Button>
                        </Col>
                        <Col style={{ textAlign: "center" }}>
                          <Button
                            className="btn-round"
                            color="info"
                            onClick={() => showAlert("download_activate")}
                          >
                            Trigger Download And Activation
                          </Button>
                        </Col>
                        <Col style={{ textAlign: "right" }}>
                          <Button
                            className="btn-round"
                            color="info"
                            onClick={() => showAlert("alternate_activate")}
                          >
                            Trigger Alternate Activation
                          </Button>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                  </CardFooter>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default FirmwareList;
